import theme from '@style';
import {Overlay} from '@rneui/themed';
import React, {
  useState,
  ReactNode,
  useCallback,
  useRef,
  useEffect,
} from 'react';
import {StyleProp, ViewStyle} from 'react-native';
import {SafeAny} from '@/types';

const {padding} = theme;

export interface ModalOptions {
  // 为0时不会主动关闭，否则延迟多久关闭
  delayClose?: number;
  // 点击外围是否关闭
  backDropClose?: boolean;
  backdropStyle?: StyleProp<ViewStyle>;
  overlayStyle?: StyleProp<ViewStyle>;
  // 点击外围关闭事件，覆盖时使用
  onBackDropClose?: () => void;
}

export function useModal(modalContent: ReactNode, options: ModalOptions = {}) {
  const [visible, setVisible] = useState<boolean>(false);
  const {
    delayClose = 0,
    overlayStyle,
    backDropClose,
    backdropStyle,
    onBackDropClose: backDropCloseFn,
  } = options;
  const timeout = useRef<NodeJS.Timeout>();
  const show = useCallback(() => {
    setVisible(true);
    if (delayClose <= 0) {
      return;
    }
    timeout.current = setTimeout(() => {
      setVisible(false);
    }, delayClose);
  }, [delayClose]);
  const hide = useCallback(() => {
    setVisible(false);
    if (timeout.current) {
      clearTimeout(timeout.current);
      timeout.current = undefined;
    }
  }, []);
  const handleBackDrop = () => {
    if (backDropClose) {
      backDropCloseFn ? backDropCloseFn() : hide();
    }
  };
  const modelRef = useRef<SafeAny>(null);

  useEffect(() => {
    if (visible && modelRef.current) {
      let parent = modelRef.current as unknown as HTMLDivElement;
      while (parent && parent.parentElement !== document.body) {
        parent = parent.parentElement as HTMLDivElement;
      }
      (parent.children[0] as HTMLDivElement).style.zIndex = 12000 + '';
    }
  }, [visible]);
  return {
    renderModal: (
      <Overlay
        isVisible={visible}
        animationType="fade"
        backdropStyle={[{backgroundColor: 'rgba(0,0,0,0.5)'}, backdropStyle]}
        overlayStyle={[padding.l, overlayStyle]}
        onBackdropPress={handleBackDrop}
        ref={modelRef}>
        {modalContent}
      </Overlay>
    ),
    show,
    hide,
  };
}
